import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { GoogleMapsLoaderService } from './common/google-maps-loader.service';
import { PhotoUploadQueueService } from './common/photo-upload-queue.service';
import { AppUpdateService } from './common/app-update.service';
import { LegalAgreementsService } from './legal/legal-agreements.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  // PhotoUploadQueueService is injected here to ensure it's instantiated at app startup.
  // Its constructor processes any queued photo uploads and sets up the online event listener.
  // Do not remove - this is required for automatic retry of failed photo uploads.
  constructor(
    protected service: AppService, 
    protected appUpdate: AppUpdateService,
    protected legal: LegalAgreementsService,
    private googleMapsLoader: GoogleMapsLoaderService,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _photoUploadQueue: PhotoUploadQueueService
  ) {
  }

  async ngOnInit() {
    this.service.init();
    
    // Load Google Maps API once at application startup
    try {
      await this.googleMapsLoader.loadGoogleMaps();
      console.log('Google Maps API loaded successfully');
    } catch (error) {
      console.error('Failed to load Google Maps API:', error);
    }
  }
}
